import { preload } from "shared/shared.preload"
import * as webElectron from "web/webElectron"

preload(webElectron)
  .then(async () => {
    const { loadRoot } = await import("./loadRoot")
    loadRoot("preview")
  })
  .catch((error) => {
    console.error("Error during preload initialization:", error)
  })
